import { inject } from '@angular/core';
import { Sites } from '@enums/sites';
import { environment } from '@environments/environment';
import { AnalyteHealthOrderService } from '@services/analyte-health-order.service';
import { HealthLabsOrderService } from '@services/healthlabs-order.service';
import { OrderService } from '@services/order.service';
import { OrderConsultationRequestService } from '@services/order-consultation-request.service';
import { STDcheckOrderService } from '@services/stdcheck-order.service';

const orderServiceFactory = () => {
  switch (environment.site) {
    case Sites.Stdcheck:
      return inject(STDcheckOrderService);

    case Sites.AnalyteHealth:
      return inject(AnalyteHealthOrderService);

    default:
    case Sites.Healthlabs:
      return inject(HealthLabsOrderService);

    case Sites.Treatmyuti:
    case Sites.Starfish:
    case Sites.Stallion:
    case Sites.TestosteroneHq:
      return inject(OrderConsultationRequestService);
  }
};

export const OrderServiceProvider = {
  provide: OrderService,
  useFactory: orderServiceFactory,
};
